import React, { useEffect, useRef } from "react";

const contactLinks = [
  {
    label: "Email",
    text: "patrickdaviscleary@gmail.com",
    href: "mailto:patrickdaviscleary@gmail.com",
  },
  {
    label: "GitHub",
    text: "github.com/PatrickCleary",
    href: "https://github.com/PatrickCleary",
  },
  {
    label: "Twitter",
    text: "@PatrickDCleary",
    href: "https://x.com/PatrickDCleary",
  },
  {
    label: "LinkedIn",
    text: "linkedin.com/in/pdcleary",
    href: "https://www.linkedin.com/in/pdcleary/",
  },
];

export const Contact = () => {
  const leftRef = useRef<HTMLDivElement>(null);
  const rightRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) =>
          e.target.classList.toggle("visible", e.isIntersecting)
        ),
      { threshold: 0.1 }
    );
    [leftRef, rightRef].forEach(
      (r) => r.current && observer.observe(r.current)
    );
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section id="contact" className="contact-section">
        <div className="reveal" ref={leftRef}>
          <p className="section-label">Get in touch</p>
          <h2 className="contact-heading">
            Let&apos;s
            <br />
            build
            <br />
            <img
              src="/Together.svg"
              alt="together"
              style={{ display: "block" }}
            />
          </h2>
        </div>
        <div className="contact-info reveal" ref={rightRef}>
          <p>
            I&apos;m open to collaborations, freelance work, and conversations
            about technology, planning, and the urban environment.
          </p>
          <div className="contact-links">
            {contactLinks.map(({ label, text, href }) => (
              <a
                key={label}
                href={href}
                className="contact-link"
                target={href.startsWith("mailto") ? undefined : "_blank"}
                rel="noopener noreferrer"
              >
                <span className="contact-link-label">{label}</span>
                {text}
              </a>
            ))}
          </div>
        </div>
      </section>
      <footer className="site-footer ">
        <p>© {new Date().getFullYear()} Patrick Cleary</p>
        <p>Built with intention.</p>
      </footer>
    </>
  );
};
